import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { DevCenterClient } from './dev-center-client.js';

export function useDevCenterClient(): DevCenterClient {
  const httpClient = useHttpClient({ type: 'backoffice' });
  return useMemo(() => new DevCenterClient(httpClient), [httpClient]);
}
